// SimpleDialog.jsx
import { View, Flex, Text } from '@aws-amplify/ui-react';

export default function SimpleDialog({
  open,
  onClose,
  header,
  title,
  children,
  maxWidth = '32rem',
}) {
  if (!open) return null; // don't render anything if closed

  return (
    <View
      // Backdrop
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      backgroundColor="rgba(0,0,0,0.35)"
      zIndex={1000}
      display="flex"
      justifyContent="center"
      alignItems="center"
      padding="1rem"
    >
      {/* Dialog panel */}
      <View
        backgroundColor="white"
        borderRadius="0.75rem"
        padding="1.25rem"
        maxWidth={maxWidth}
        width="100%"
        boxShadow="0 10px 30px rgba(0,0,0,0.25)"
      >
        {header && (
          <View marginBottom="0.75rem">
            {header}
          </View>
        )}
        <Flex
          alignItems="center"
          justifyContent="space-between"
          marginBottom="0.75rem"
        >
          <Text as="h2" fontSize="lg" fontWeight="600">
            {title}
          </Text>
          <button
            type="button"
            onClick={onClose}
            style={{
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              padding: '0.1rem 0.4rem',
              borderRadius: '0.375rem',
            }}
            aria-label="Close"
          >
            ✕
          </button>
        </Flex>

        {children}
      </View>
    </View>
  );
}
